// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_pricinglevel_code: yup.string().label("Pricing level code").required(),
  mr_product_pricinglevel_name: yup.string().label("Pricing level name").required()
})